import { LOGGED_OUT } from "./constants";
import { LoggedOutAction } from "./types";

export const SET_DEFAULT_POS = "SET_DEFAULT_POS";
export const DELETE_DEFAULT_POS = "DELETE_DEFAULT_POS";
export const ADD_TO_POS_DEVICES = "ADD_TO_POS_DEVICES";
export const REMOVE_FROM_POS_DEVICES = "REMOVE_FROM_POS_DEVICES";

export interface PcPosConfig {
  uniqueId: string;
  pspId: string;
  ip: string;
  port: string;
  pspName: string;
  posName: string;
  logo: string;
}
export interface PosState {
  pcpos: { active?: PcPosConfig; list: PcPosConfig[] };
  mpos: { terminalId?: string };
}

export interface SetDefaultPosAction {
  type: typeof SET_DEFAULT_POS;
  payload: { uniqueId: string };
}

export interface DeleteDefaultPosAction {
  type: typeof DELETE_DEFAULT_POS;
}

export interface AddToPosDevicesAction {
  type: typeof ADD_TO_POS_DEVICES;
  payload: { config: PcPosConfig };
}

export interface RemoveFromPosDevicesAction {
  type: typeof REMOVE_FROM_POS_DEVICES;
  payload: { uniqueId: string };
}

export type PosActionTypes =
  | SetDefaultPosAction
  | DeleteDefaultPosAction
  | AddToPosDevicesAction
  | RemoveFromPosDevicesAction
  | LoggedOutAction;

const initialState: PosState = {
  mpos: { terminalId: undefined },
  pcpos: {
    active: undefined,
    list: [],
  },
};

export default function pos(state = initialState, action: PosActionTypes): PosState {
  if (action.type === SET_DEFAULT_POS) {
    const { uniqueId } = action.payload;
    const activePos = state.pcpos.list.find((device) => device.uniqueId === uniqueId);

    return { ...state, pcpos: { ...state.pcpos, active: activePos } };
  }

  if (action.type === DELETE_DEFAULT_POS) {
    return { ...state, pcpos: { ...state.pcpos, active: initialState.pcpos.active } };
  }

  if (action.type === ADD_TO_POS_DEVICES) {
    const { pspId, ip, port, pspName, posName, logo } = action.payload.config;

    const uniqueId = `${pspId}${ip}${port}${Math.random()}`;
    const newPos = { ip, logo, port, posName, pspId, pspName, uniqueId };
    const devices = [...state.pcpos.list, newPos];

    return { ...state, pcpos: { ...state.pcpos, list: devices } };
  }

  if (action.type === REMOVE_FROM_POS_DEVICES) {
    const { uniqueId } = action.payload;

    const devices = state.pcpos.list.filter((device) => device.uniqueId !== uniqueId);
    let activePos = state.pcpos.active;
    if (state.pcpos.active?.uniqueId === uniqueId) {
      activePos = initialState.pcpos.active;
    }
    return { ...state, pcpos: { ...state.pcpos, active: activePos, list: devices } };
  }

  if (action.type === LOGGED_OUT) {
    return state;
  }

  return state;
}
